import LicenseManagement from "../../components/LicenseManagement";

const LicenseManagementPage = () => {
  return <LicenseManagement />;
};

export default LicenseManagementPage;
